import { Application } from 'libapi';
import React, { ReactNode, useContext, useState } from 'react';
import { ApplicationContext } from '../App';
import { useMachineConfig } from './General';
import { KeyboardContext, KeyboardTrigger } from './Layout';
import { getChangeWrapperString } from './shared/shared';

// Styles
export interface ModalProps {
	close(): any;
}

interface ModalPropsChildren extends ModalProps {
	children: ReactNode;
}

export default function Modal({ children, close }: ModalPropsChildren) {
	const modal_class: string = 'Modal';
	const close_modal = (e: React.MouseEvent<HTMLElement>) => {
		let target = e.target as HTMLElement;
				 if (target.className === modal_class) {
				 close();
				 }
	};
	return (
		<div className={modal_class} onClick={close_modal} style={{zIndex: 5}}>
			{children}
		</div>
	);
}

interface UnlockProps {
	close(): void;
}

function UnlockItem(props: any) {
	return <div className="UnlockItem">{props.children}</div>;
}

export function Unlock({ close }: UnlockProps) {
	let [valid, set_valid] = useState<boolean>(false);

	const app = useContext(ApplicationContext) as Application;

	const { lMachineConfig } = useMachineConfig(app);
	let [incorrectAttempt, setIncorrectAttempt] = useState<boolean>(false);

	const lKeyboardTrigger: KeyboardTrigger = useContext(KeyboardContext);

	const lInputHandlers = getChangeWrapperString(async function (
		pNewValue: string
	) {
		console.log('testing string!');
		if (lMachineConfig && lMachineConfig.SupervisorCode === pNewValue) {
			setIncorrectAttempt(false);
			close();
		} else {
			setIncorrectAttempt(true);
		}
	});
	const lTriggerKeyboard = function () {
		if (lKeyboardTrigger) {
			lKeyboardTrigger(`Enter password to unlock`, '', lInputHandlers.Direct);
		}
	};

	return (
		<>
			{lMachineConfig?.SupervisorCode && (
				<Modal close={() => {}}>
					<div className="Unlock">
						<UnlockItem>
							<span id="UnlockTitle">{'Enter password to unlock'}</span>
						</UnlockItem>
						<UnlockItem>
							<input
								type="password"
								id="unlock"
								onChange={lInputHandlers.Event}
								onClick={lTriggerKeyboard}
							/>
						</UnlockItem>
						<UnlockItem>
							{incorrectAttempt && <span>Incorrect password.</span>}
						</UnlockItem>
					</div>
				</Modal>
			)}
		</>
	);
}
